import React from 'react';
import {Form} from 'react-bootstrap';

/**
 * Renders a pair of radio buttons for left/right socket or charging point selection.
 *
 * @param {object} props
 * @param {{values: number[], labels: string[]}} props.socket — resolved socket config
 * @param {object} props.formData — current EV charger form data
 * @param {function} props.setFormData — state setter for form data
 */
const SocketSelector = ({socket, formData, setFormData}) => {
  const [leftVal, rightVal] = socket.values;
  const [leftLabel, rightLabel] = socket.labels;

  return (
    <>
      <Form.Label>Socket ID:</Form.Label>
      <div className="d-flex">
        <Form.Check
          type="radio"
          label={leftLabel}
          name="socketId"
          checked={formData?.socketId === leftVal}
          onChange={() => setFormData({...formData, socketId: leftVal})}
        />
        <Form.Check
          className="ms-2"
          type="radio"
          label={rightLabel}
          name="socketId"
          checked={formData?.socketId === rightVal}
          onChange={() => setFormData({...formData, socketId: rightVal})}
        />
      </div>
    </>
  );
};

export default SocketSelector;

